// @flow
import { Navigate } from 'react-router';
import { INSIGHT_GENERAL_OVERVIEW } from './InsightRouteConstants';
import { useSelector } from 'react-redux';
import { isDefined } from 'util/ObjectUtils';
import { isUserAuthenticated } from '../../store/selector/UserSelector';
import PublicPage from '../../insight/pages/PublicPage';

const PublicRoute = ({ children, noRedirect = false, withLogo = true }: any): React$Node => {
  const authenticated = useSelector(isUserAuthenticated);

  let navigateTo = null;
  if (authenticated && !noRedirect) {
    navigateTo = INSIGHT_GENERAL_OVERVIEW;
  }

  return isDefined(navigateTo) ? (
    <Navigate to={navigateTo} replace />
  ) : (
    <PublicPage withLogo={withLogo}>{children}</PublicPage>
  );
};

export default PublicRoute;
